/**
 * WordPress dependencies
 */
import {
	__experimentalHStack as HStack,
	Icon as WCIcon,
} from '@wordpress/components';

/**
 * Internal dependencies
 */
import type { BasePost } from '../../types';
import STATUSES from './status-elements';

function StatusView( { item }: { item: BasePost } ) {
	const status = STATUSES.find( ( { value } ) => value === item.status );
	const label = status?.label || item.status;
	const icon = status?.icon;
	return (
		<HStack alignment="left" spacing={ 0 }>
			{ icon && (
				<div className="fields-controls__status-icon">
					<WCIcon icon={ icon } />
				</div>
			) }
			<span>{ label }</span>
		</HStack>
	);
}

export default StatusView;
